import { ReactNode } from 'react';
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../Dialog';

interface Props {
  hideModal: () => void;
  show?: boolean;
  title: string | ReactNode;
  instructions?: string | ReactNode;
  message: string | ReactNode;
}

const GenericInformationModal = ({ hideModal, show = true, title, message, instructions }: Props): JSX.Element => {
  return (
    <Dialog
      open={show}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          hideModal();
        }
      }}
    >
      <DialogContent className='w-[min(95vw,500px)] overflow-hidden rounded-[15px] border-0 bg-white p-0 shadow-[0_14px_34px_rgba(0,0,0,0.2)]'>
        <DialogHeader className='relative h-[40px] flex-row items-center justify-center bg-[#ff671d] px-0 py-0'>
          <DialogTitle asChild>
            <h2 className="m-0 font-['GT-Walsheim-Pro-Regular'] text-center text-[2rem] leading-[1] text-white">
              {title}
            </h2>
          </DialogTitle>
          <button
            type='button'
            className='absolute right-[10px] top-1/2 inline-flex h-[24px] w-[24px] -translate-y-1/2 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-[2.4rem] font-normal leading-none text-white transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80'
            onClick={hideModal}
            aria-label='Close information dialog'
          >
            x
          </button>
        </DialogHeader>

        <DialogBody className='pt-[2.4em]'>
          <p className="mb-0 flex flex-col px-[3em] font-['GT-Walsheim-Pro-Light'] text-[1.7rem] leading-[1.5] text-[#3f3f3f] max-[468px]:px-[1em] max-[468px]:py-[2em]">
            {message}
          </p>
          {instructions && (
            <p className="mb-0 flex flex-col px-[3em] font-['GT-Walsheim-Pro-Light'] text-[1.7rem] leading-[1.5] text-[#3f3f3f] max-[468px]:px-[1em] max-[468px]:py-[2em]">
              {instructions}
            </p>
          )}
        </DialogBody>

        <DialogFooter className='justify-center px-0 pb-[1.6em] pt-[1.2em]'>
          <button
            type='button'
            onClick={hideModal}
            className="inline-flex h-[46px] min-w-[180px] items-center justify-center rounded-[4px] border-0 bg-[#1aa6c9] px-[4em] font-['GT-Walsheim-Pro-Bold'] text-[1.6rem] leading-none text-white"
          >
            OK
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GenericInformationModal;
